/* eslint-disable camelcase */
import { apiRequest } from '@zr/utilities/api';

const APPLY_SUGGESTIONS_URL = '/apply/api/suggestions';

// camelcase disabled for convenience (using args directly for expected snake case body)
export async function suggestionReply(enc_response_id, suggestion_key, suggestion_reply, extra = {}) {
  const params = new URLSearchParams();
  const body = {
    suggestion_key,
    suggestion_reply,
    ...extra,
  };

  Object.keys(body).forEach((key) => {
    params.set(key, body[key]);
  });


  const fetchInit = {
    method: 'POST',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: params.toString(),
  };

  const response = await apiRequest(`${APPLY_SUGGESTIONS_URL}/${enc_response_id}`, fetchInit);


  const json = await response.json();

  // unsure what to do if !json.success but no message
  if (!json.success) {
    throw new Error(json.message || '');
  }
}

export default suggestionReply;
